// ─────────────────────────────────────────────────────────────────────────────
// KLOTHIQ — useDebounce hook
// ─────────────────────────────────────────────────────────────────────────────
// Simple debounce hook — no external dependency needed.
// ─────────────────────────────────────────────────────────────────────────────
import { useState, useEffect } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
